'use client';

import { SnapWalletAdapter } from '@drift-labs/snap-wallet-adapter';
import { WalletAdapterNetwork, WalletError } from '@solana/wallet-adapter-base';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import '@solana/wallet-adapter-react-ui/styles.css';
import {
  // BackpackWalletAdapter,
  LedgerWalletAdapter,
  PhantomWalletAdapter,
  SalmonWalletAdapter,
  SolflareWalletAdapter,
  TrustWalletAdapter,
} from '@solana/wallet-adapter-wallets';
import { clusterApiUrl } from '@solana/web3.js';
import { PropsWithChildren, useCallback, useMemo } from 'react';
// import { toast } from 'react-toastify';
// import { logger } from '../../../utils/logger';

export function SolanaWalletContext({ children }: PropsWithChildren<unknown>) {
  // TODO support multiple networks
  const network = WalletAdapterNetwork.Mainnet;
    const endpoint = useMemo(
        () => 'https://rpc.ankr.com/solana/89f1f6c49a654c7d12baa44be8b44b15311c45289aab04d1d892b866174d4f7f',
        [],
    );
  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
      new SolflareWalletAdapter(),
      // new BackpackWalletAdapter(),
      new SalmonWalletAdapter(),
      new SnapWalletAdapter(),
      new TrustWalletAdapter(),
      new LedgerWalletAdapter(),
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [network],
  );

  const onError = useCallback((error: WalletError) => {
      console.error(error);
    // logger.error('Error initializing Solana wallet provider', error);
    // toast.error('Error preparing Solana wallet');
  }, []);

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} onError={onError} autoConnect>
        <WalletModalProvider>{children}</WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}
